import { VendorInvoiceFileStatusLabels } from "../invoiceConsts.ts";
import { arrayToObject } from "utils/object-util";

const statusLabelLookup = arrayToObject(VendorInvoiceFileStatusLabels, 'id');

const StatusLabel = ({ status }) => {
    const statusObj = statusLabelLookup[status];
    return (
        <span style={{ color: statusObj?.color || undefined }}>
            {statusObj?.name}
        </span>
    );
};

export default StatusLabel;